// Can be accessed at locale.t('populationStep.<key>')

export default {
  inline: {
    seedDescription:
      'Define the Seed Value. A given Seed Value will always return the same randomization, ensuring that the limit population step provides consistent results for a given population size. For example, if a given entity ID is included in a 50% sample given a population size of N, then that entity ID will always be in a 50% sample in a population size of N, even if the filtering conditions change for the population or the data changes. If a Seed Value is not specified, the Seed Value is set to zero. If you input a seed value, you will alter the randomization so that a different set of random entity IDs are selected in the population step.'
  },
  tooltip: {}
}
